import { Component, ElementRef, OnInit, Renderer2, ViewChild, HostListener, OnDestroy } from '@angular/core'
import { ArribalAtPlant, AttributeValues, Client, IDetailTripResponse } from 'src/app/interfaces/Responses/IDetailTripResponse'
import { Indicators, Point, Step } from 'src/app/interfaces/Responses/IRealTimeDashboardResponse'
import { Plate } from 'src/app/interfaces/Responses/ITrucksByCheckpointResponse'
import { RealTimeService } from '../../../services/dashboards/real-time.service'
import * as signalR from '@microsoft/signalr'
import { AuthService } from 'src/app/services/auth.service'
import { ActivatedRoute, Router } from '@angular/router'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { GeneralService } from 'src/app/services/dashboards/general.service'
import { Image } from '../../../interfaces/Responses/IDetailTripResponse'
import { environment } from 'src/environments/environment'
import { Subscription } from 'rxjs'
import { RequestTripDetail } from 'src/app/interfaces/RequestTripDetail'
import { DeviceDetail, SourceDevicesDto } from 'src/app/interfaces/Responses/ISourceDevicesStatusResponse'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'neoris-real-time-dashboard',
  templateUrl: './real-time-dashboard.component.html',
  styleUrls: ['./real-time-dashboard.component.css']
})
export class RealTimeDashboardComponent implements OnInit, OnDestroy {

  currentEntry = 0
  currentSilo = 0
  currentExit = 0
  miFP: string
  points: Point[] = []
  indicators: Indicators
  yards: Point
  stepsYards: Step[]
  currentStep: Step
  silos: Point
  stepsSilos: Step[]
  currentStepSilo: Step
  exits: Point
  stepsExits: Step[]
  currentStepExit: Step
  currentDate: string
  siloName: string
  exitName: string
  pointModal: string
  responseStatus: SourceDevicesDto
  modalActivo: boolean = false
  @ViewChild('popup') popup: ElementRef
  @ViewChild('popup2') popup2: ElementRef
  @ViewChild('popup3') popup3: ElementRef
  @ViewChild('blur') blur: ElementRef
  listPlatesByCheckpoint: Plate[]
  tripID: string
  private _hubConnection: signalR.HubConnection
  notificationHub = environment.urlHub
  desktopView: MediaQueryList = matchMedia('(min-width: 1280px)')
  existTripB: boolean
  response: IDetailTripResponse
  responseModal: IDetailTripResponse
  lastTimeOnPlant: string
  lastPointOnPlant: string
  type: string
  dashboardtypelegend: string = "3"
  dashboardtype:string
  _site: string
  editPlateForm: UntypedFormGroup
  filterImagesZone: UntypedFormGroup
  editPlateForm1: UntypedFormGroup
  editable: boolean = false
  editable1: boolean = false
  currentIndexImage: number = 0
  currentIndexImage1: number = 0
  @ViewChild('image') image: ElementRef
  @ViewChild('image1') image1: ElementRef
  activeModal: number
  currentOrder = 8
  htmlString: any
  notFound: boolean = false
  messageNotFound: string = ''
  allImages: Image[] = []
  _filterImages: Image[] = []
  anyImages: boolean = false
  _dashboardId: string
  _tripID: string
  parentMessage: IDetailTripResponse
  myval: AttributeValues
  hasLocalStorage: boolean
  platesShowAll: Plate[]
  isIndustrial:boolean;
  onOff: boolean = false;

  @HostListener('document:click', ['$event.target'])
  handleClick($evt: HTMLElement): void {
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(evt: KeyboardEvent) {
    if (evt.key === 'Escape') {
      if (this.activeModal === 1) {
        this.configurarModal()
        this.activeModal = 0
      }
      if (this.activeModal === 2) {
        this.configurarModal2()
        this.activeModal = 0
      }
      if (this.activeModal === 3) {
        this.configurarModal3()
        this.activeModal = 0
      }
    }
  }

  subscription: Subscription

  detailTruckForm: UntypedFormGroup
  responseDetail: IDetailTripResponse
  _edit: boolean = false
  imagesOfTrucks: Image[]
  arribalAtPlant: ArribalAtPlant[]
  companies: Client[] = []
  types: AttributeValues[] = []
  currentLicensePlate: string
  currentTruckNumber: string
  currentCompany: string
  currentDotNumber: string
  currentType: string

  slidePosition = 0;
  slides: any
  totalSlides: number = 0

  ImagesCheckPoint: any[] = []

  constructor(
    private builder: UntypedFormBuilder,
    private renderer: Renderer2,
    private realTimeService: RealTimeService,
    public authService: AuthService,
    private rutaActiva: ActivatedRoute,
    private generalService: GeneralService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.isIndustrial = environment.isIndustrial
  }

  ngOnDestroy(): void {
    this._hubConnection.off('ReceiveNotification')
    this.subscription.unsubscribe()
  }
  filterEntry(order: number, id: number, stepName: string) {
    this.currentEntry = order
    document.getElementById(`name-point-${id}-1`).innerHTML = `list of trucks of ${stepName}`
  }
  filterSilos(order: number, id: number, stepName: string) {
    this.currentSilo = order
    document.getElementById(`name-point-${id}-2`).innerHTML = `list of trucks of ${stepName}`
  }
  filterExit(order: number, id: number, stepName: string) {
    this.currentExit = order
    document.getElementById(`name-point-${id}-3`).innerHTML = `list of trucks of ${stepName}`
  }

  configForm() {
    this.editPlateForm = this.builder.group({
      licensePlate: ['']
    })
  }

  configForm1() {
    this.editPlateForm1 = this.builder.group({
      licensePlate1: ['']
    })
  }

  configForm2() {
    this.filterImagesZone = this.builder.group({
      images: ['']
    })
  }

  changeSize(mql) {
  }

  validate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode
    if (charCode >= 65 && charCode <= 90) return true
    if (charCode >= 97 && charCode <= 122) return true
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  validatePaste(event: ClipboardEvent): boolean {
    let clipboardData = event.clipboardData
    let pastedText = clipboardData.getData('text')
    return this.soloLetrasYNum(pastedText)
  }

  soloLetrasYNum(campo: any): boolean {
    let validos = 'abcdefghijklmnñopqrstuvwxyz0123456789'
    let letra: string
    let bien = true
    for (let i = 0; i < campo.length; i++) {
      letra = campo.charAt(i).toLowerCase()
      if (validos.indexOf(letra) == -1) bien = false
    }
    return bien
  }

  beEditable() {
    document.getElementById('licensePlate').removeAttribute('disabled')
    this.editable = true
  }

  beEditable1() {
    document.getElementById('licensePlate1').removeAttribute('disabled')
    this.editable1 = true
  }

  beNotEditable() {
    let platenumber = document.getElementById('platenumber').innerHTML
    let inputValue = <HTMLInputElement>(document.getElementById('licensePlate'))
    inputValue.value = platenumber
    document.getElementById('licensePlate').setAttribute('disabled', 'true')
    this.editable = false
  }

  beNotEditable1() {
    let platenumber = document.getElementById('platenumber1').innerHTML
    let inputValue = <HTMLInputElement>(document.getElementById('licensePlate1'))
    inputValue.value = platenumber
    document.getElementById('licensePlate1').setAttribute('disabled', 'true')
    this.editable1 = false
  }

  editPlate(values: any) {
    let licensePlate = values.licensePlate
    let tripid = document.getElementById('tripid').innerHTML
    this.generalService.updatePlateByTripID(tripid, licensePlate).subscribe((r) => {
      if (r.data) {
        document.getElementById('licensePlate').setAttribute('disabled', 'true')
        this.editable = false
        document.getElementById('update-lp').style.display = 'block'
        setTimeout(() => {
          document.getElementById('update-lp').style.display = 'none'
        }, 3000)
      }
    })
  }

  editPlate1(values: any) {
    let licensePlate = values.licensePlate1
    let tripid = document.getElementById('tripid1').innerHTML
    this.generalService.updatePlateByTripID(tripid, licensePlate).subscribe((r) => {
      if (r.data) {
        document.getElementById('licensePlate1').setAttribute('disabled', 'true')
        this.editable1 = false
        document.getElementById('update-lp1').style.display = 'block'
        setTimeout(() => {
          document.getElementById('update-lp1').style.display = 'none'
        }, 3000)
      }
    })
  }

  setImage(arg0: number, images: Image[]) {
    if (arg0 !== undefined) this.currentIndexImage = arg0
    document.querySelectorAll('.image-page').forEach(element => {
      element.classList.remove('active')
    })
    let _currentIndexImage = document.querySelector(`#image-${this.currentIndexImage}`)
    if (_currentIndexImage !== undefined && _currentIndexImage !== null)
      _currentIndexImage.classList.add('active')
    this.renderer.setAttribute(this.image.nativeElement, 'src', images[this.currentIndexImage].imagE_URL)
    this.renderer.setAttribute(this.image.nativeElement, 'alt', images[this.currentIndexImage].steP_NAME)
  }

  setImage1(arg0: number, images: Image[]) {
    if (arg0 !== undefined) this.currentIndexImage1 = arg0
    document.querySelectorAll('.image-page').forEach(element => {
      element.classList.remove('active')
    })
    document.querySelector(`#image1-${this.currentIndexImage1}`).classList.add('active')
    this.renderer.setAttribute(this.image1.nativeElement, 'src', images[this.currentIndexImage1].imagE_URL)
    this.renderer.setAttribute(this.image1.nativeElement, 'alt', images[this.currentIndexImage1].steP_NAME)
  }

  ngOnInit(): void {
    this.htmlString = ''
    this.configForm()
    this.configForm1()
    this.configForm2()
    this.configDetailTrip()

    this._site = localStorage.getItem('site')
    if(this._site.includes(",") === true)
      {  
        this.router.navigate(['home']);
      }


    this.type = this.rutaActiva.snapshot.params.type
    this.connectionHub()
    this.LoadData()
    let today = new Date()
    this.currentDate = today.toLocaleDateString()
    this.desktopView.addEventListener('change', this.changeSize)
    this.changeSize(this.desktopView)
    this.slides = document.getElementsByClassName('carousel__item')
  }

  configDetailTrip() {
    this.detailTruckForm = this.builder.group({
      plateNumber: [''],
      truckNumber: [''],
      govNumber: [''],
      dotNumber: [''],
      attributeValue: ['']
    })
  }

  changeType(type: string) {
  }

  onKeyLP(value: any) {
  }

  onKeyTN(value: string) {
  }

  onKeyDN(value: string) {
  }

  changeCompany(company: string) {
    this.responseDetail.dotNumber = company
    this.currentDotNumber = company
    document.getElementById('dotNumber').setAttribute('placeholder', company)
    document.getElementById('dotNumber').setAttribute('value', company)
  }

  UpdateDetailTruck(values: any) {
    let requesTripDetail = new RequestTripDetail()
    requesTripDetail.tripId = Number(this._tripID)
    requesTripDetail.license = this.currentLicensePlate
    requesTripDetail.dotNumber = this.currentDotNumber
    requesTripDetail.truckNumber = this.currentTruckNumber
    requesTripDetail.truckType = Number(this.currentType)
    
    this.realTimeService.UpdateTripDetail(requesTripDetail).subscribe((e) => {
      document.getElementById('resolution').style.display = 'block'
      setTimeout(() => {
        document.getElementById('resolution').style.display = 'none'
      }, 3000)
    })
    this.toogleEdit()
  }

  toogleEdit() {
    this._edit = !this._edit
  }

  edit() {
    this.toogleEdit()
  }

  zoom(images: any) {

    if(images !== undefined || images !== null){
      const arr = images as Array<any>;

      if(arr !== undefined){
        console.log("arr", arr);
      }else{
        console.log("no arr", arr);
      }

      this.totalSlides = arr.length
      this.ImagesCheckPoint = arr
      this.slides[0].classList.add('carousel__item--visible')
       document.getElementById('myModal').style.display = 'block'

       console.log("arr", arr)
    }
  }

  closeModal() {
    document.getElementById('myModal').style.display = 'none'
    this.totalSlides = 0
    this.ImagesCheckPoint = []
  }

  LoadData() {
    if (this.subscription?.closed !== false) {
      this.subscription = this.realTimeService.getRealTimeDashboard(this._site, this.type).subscribe((data) => {
        if(this.isIndustrial){
          this.getStatusDevices()
        }
        this.indicators = data.indicators
        if (this.indicators !== null) this.dashboardtype = this.indicators?.dashboarD_TYPE_ID
        if (this.indicators !== null) this.points = data.checkpoint.points
        this.dashboardtypelegend = this.points.length.toString()
      })
    }
  }

  loadTrip(fp: number) {
    this.miFP = fp.toString()
  }

  getTextPlate(plate: string, colour: string): string {
    let textPlate: string = `<div style="
                    display: flex;
                    justify-content: space-between;
                    margin: 8px 0px;
                    border: 1px solid #e9ebef;
                    border-radius: 4px;
                    padding: 8px 12px;
                    transform: matrix(1, 0, 0, 1, 0, 0);">
                    <div>
                    <span style="
                    font-size: 14px;
                    color: ${colour};
                    ">LP. ${plate}</span>
                    </div>
                    <div>
                    <div style="font-size: 14px;color: #3fa9f5;
                    cursor: pointer;"><img src="../../../../assets/images/Icons/Eye.png" alt="" style="
                    width: 14px;"><span style="
                    padding-left: 5px;" (click)="goToModalDetail('${plate}')">View</span>
                    </div>
                    </div>
                    </div>`
    return textPlate
  }

  filter(point: Point, id: number, steP_LOC_ID: number, stepName: string, order: number, i: number) {
     console.log(point, id, steP_LOC_ID, stepName)
     console.log(order)
    this.currentOrder = steP_LOC_ID
    let plates = point.steps.filter(s => s.steP_LOC_ID === steP_LOC_ID)[0].plates
     console.log('this.currentOrder', this.currentOrder)
     console.log(plates)

    document.getElementById(`name-point-${id}`).innerHTML = `list of trucks of ${stepName}`
    

    let listSteps: string = ''


    for (let index = 0; index < plates.length; index++) {
      switch (plates[index].avG_TIME_COLOR) {
        case 'OK':
          listSteps += this.getTextPlate(plates[index].licensE_PLATE, '#333333')
          break
        case 'ERROR':
          if (plates[index].licensE_PLATE === '') {
            listSteps += this.getTextPlate('Unidentified', '#dc4d4a')
          } else {
            listSteps += this.getTextPlate(plates[index].licensE_PLATE, '#dc4d4a')
          }
          break
        case 'WARNING':
          listSteps += this.getTextPlate(plates[index].licensE_PLATE, 'rgb(249, 208, 135)')
          break
      }
      
    }

    listSteps += `<div style="text-align: center;">
      <span style="font-size: 14px;
      color: #3fa9f5;
      cursor: pointer;">
        <img style="width: 14px;" src="../../../../assets/images/Icons/Eye.png" alt="">
        <span style="padding-left: 5px;" (click)=showAll(${point})>Show all trucks</span>
      </span>
    </div>`
    this.htmlString = listSteps
  }

  searchByPlate() {
    let plate = (<HTMLInputElement>(document.getElementById('searchtoplate'))).value
    if (plate === '') {
      this.LoadData()
    } else {
      this.realTimeService.getRealTimeDashboardByPlate(this._site, plate, this.type).
        subscribe(data => {
          if (data.lasttrip === null) {
            if (data.message === null) {
              this.indicators = data.indicators
              this.points = data.checkpoint.points
            } else {
              this.notFound = true
              this.messageNotFound = data.message
              setTimeout(() => {
                this.notFound = false
                this.messageNotFound = ''
              }, 3000);
            }
          } else {
            this.activeModal = 3
            this.configurarModal3()
            this.lastTimeOnPlant = data.lasttrip.lasT_DATE_TRUCK_ONLINE
            this.lastPointOnPlant = data.lasttrip.lasT_LOCATION_NAME
          }
        })
    }
  }

  getStatusDevices() {
      this.realTimeService.getSourceDevicesStatus(this._site)
      .subscribe(response => {
        console.log(response.error)
        if (response.devices != null) {
          this.responseStatus = response
          this.onOff = this.setLiveModeOn(this.responseStatus.devices)
          if (this.onOff) document.getElementById('ledOnOff').style.background = '#8cc658'
          else document.getElementById('ledOnOff').style.background = '#dc4d4a'
        }
      })
  }

  setLiveModeOn(devices: DeviceDetail[]): boolean {
    let onOff: boolean = true
    if (devices !== null && devices.length > 0) {
      devices.forEach(element => {
        if (element.online === false) {
          onOff = false
        }
      });
    }
    return onOff
  }

  configurarModal() {
    this.existTripB = false
    this.modalActivo = !this.modalActivo
    if (this.modalActivo) {
      this.renderer.addClass(this.blur.nativeElement, 'active')
      this.renderer.addClass(this.popup.nativeElement, 'active')
    }
    else {
      this.renderer.removeClass(this.blur.nativeElement, 'active')
      this.renderer.removeClass(this.popup.nativeElement, 'active')
    }
  }

  configurarModal2() {
    this.modalActivo = !this.modalActivo
    if (this.modalActivo) {
      this.renderer.addClass(this.blur.nativeElement, 'active')
      this.renderer.addClass(this.popup2.nativeElement, 'active')
    }
    else {
      this.renderer.removeClass(this.blur.nativeElement, 'active')
      this.renderer.removeClass(this.popup2.nativeElement, 'active')
    }
  }

  configurarModal3() {
    this.modalActivo = !this.modalActivo
    if (this.modalActivo) {
      this.renderer.addClass(this.blur.nativeElement, 'active2')
      this.renderer.addClass(this.popup3.nativeElement, 'active2')
    }
    else {
      this.renderer.removeClass(this.blur.nativeElement, 'active2')
      this.renderer.removeClass(this.popup3.nativeElement, 'active2')
    }
  }

  closeModalDetail() {
    document.getElementById('modalDetail').style.display = 'none'
  }

  closeModalAllTrucks() {
    document.getElementById('modalAllTrucks').style.display = 'none'
    this.platesShowAll = null
  }

  showAll(point: Point) {
    this.realTimeService.getTrucksByCheckpoint(point.poinT_ID.toString(), this._site, this.type)
      .subscribe(data => {
        if (data.plates != null && data.plates.length > 0) {
          this.platesShowAll = data.plates
          document.getElementById('modalAllTrucks').style.display = 'block'
        } else {
          alert(`no hay datos`)
        }
      })
  }

  getDetail(plate: Plate) {
    this.responseModal = null
    this.realTimeService.getDetailTrip(plate.triP_ID, this.type, this.hasLocalStorage).subscribe(
      res => {
        this.responseModal = res
      }
    )
  }

  private checkLocalStorage(): void {
    const data = localStorage.getItem('data-detail-companies');
    this.hasLocalStorage = data !== null;
    if (this.hasLocalStorage) {
      this.companies = JSON.parse(data);
    }
  }
  
  private processResponse(res: any): void {
    if (res !== null) {
      this.parentMessage = res;
      this.responseDetail = res;
      this.setCurrentValues(res);
      this.arribalAtPlant = this.getArribalAtPlant(this.responseDetail);
  
      if (!this.hasLocalStorage && res.companies && res.companies.length > 0) {
        this.companies = this.getCompanies(res.companies);
        localStorage.setItem('data-detail-companies', JSON.stringify(this.companies));
        this.hasLocalStorage = true;
      }
  
      if (res.attributeValues && res.attributeValues.length > 0) {
        this.types = this.getTypes(res.attributeValues);
      }
  
      setTimeout(() => {
        if (this.responseDetail.dotNumber !== null) this.checkedCompany(Number(this.responseDetail.dotNumber));
        if (this.responseDetail.type !== null) this.checkedType(Number(this.responseDetail.type));
      }, 500);
  
      document.getElementById('modalDetail').style.display = 'block';
    }
  }
  
  goToModalDetail(lp: Plate): void {
    this.checkLocalStorage();
  
    this.responseDetail = null;
    this.arribalAtPlant = null;
    this._tripID = lp.triP_ID;
  
    this.realTimeService.getDetailTrip(this._tripID, this.type, this.hasLocalStorage).subscribe(
      res => this.processResponse(res)
    );
  }

  /*goToModalDetail(lp: Plate) {
    if (localStorage.getItem('data-detail-companies') === null) {
      this.hasLocalStorage = false
    } else {
      this.hasLocalStorage = true
      this.companies = JSON.parse(localStorage.getItem('data-detail-companies'))
    }

    this.responseDetail = null
    this.arribalAtPlant = null
    this._tripID = lp.triP_ID
    this.realTimeService.getDetailTrip(this._tripID, this.type, this.hasLocalStorage).subscribe(
      res => {
        if (res !== null) {
          this.parentMessage = res
          this.responseDetail = res
          this.setCurrentValues(res)
          this.arribalAtPlant = this.getArribalAtPlant(this.responseDetail)
          if (localStorage.getItem('data-detail-companies') === null) {
            if (res.companies != null && res.companies.length > 0) {
              if (this.hasLocalStorage === false) {
                this.companies = this.getCompanies(res.companies)
                localStorage.setItem('data-detail-companies', JSON.stringify(this.companies))
                this.hasLocalStorage = true
              }
            }
          }
          if (res.attributeValues != null && res.attributeValues.length > 0) {
            this.types = this.getTypes(res.attributeValues)
          }
          setTimeout(() => {
            if (this.responseDetail.dotNumber !== null) this.checkedCompany(Number(this.responseDetail.dotNumber))
            if (this.responseDetail.type !== null) this.checkedType(Number(this.responseDetail.type))
          }, 500);
          document.getElementById('modalDetail').style.display = 'block'
        }
      }
    )
  }
*/
  checkedCompany(govNumber: number) {
    let company = this.companies.filter(c => c.govNumber === govNumber)
    if (company.length > 0) this.companies.filter(c => c.govNumber === govNumber)[0].selected = true
  }

  checkedType(id: number) {
    let type = this.types.filter(c => c.id === id)
    if (type.length > 0) this.types.filter(c => c.id === id)[0].selected = true
  }

  setCurrentValues(res: IDetailTripResponse) {
    this.currentLicensePlate = res.platE_NUMBER
    this.currentTruckNumber = res.truckNumber
    this.currentCompany = res.dotNumber
    this.currentDotNumber = res.dotNumber
  
  }

  getCompanies(companies: Client[]): Client[] {
    let companiesList: Client[] = []
    let companiesObj: Client
    companies.forEach(element => {
      companiesObj = new Client()
      companiesObj.name = element.name
      companiesObj.govNumber = element.govNumber || 0
      companiesObj.selected = false
      companiesList.push(companiesObj)
    })
    return companiesList
  }

  getTypes(attributeValues: AttributeValues[]): AttributeValues[] {
    let typeList: AttributeValues[] = []
    let typeObj: AttributeValues
    attributeValues.forEach(element => {
      typeObj = new AttributeValues()
      typeObj.id = element.id
      typeObj.nameEn = element.nameEn
      typeObj.nameEs = element.nameEs
      typeObj.selected = false
      typeList.push(typeObj)
    })
    return typeList
  }

  getArribalAtPlant(responseDetail: IDetailTripResponse): ArribalAtPlant[] {
    let arribalAtPlant: ArribalAtPlant[] = []
    let arribalAtPlantObj: ArribalAtPlant
    
    responseDetail?.checkpoinT_STEPS?.forEach(element => {
      arribalAtPlantObj = new ArribalAtPlant()
      arribalAtPlantObj.steP_NAME = element.steP_NAME
      arribalAtPlantObj.averagE_TIME = element.averagE_TIME
      arribalAtPlantObj.averagE_MINUTES = element.averagE_MINUTES
      arribalAtPlantObj.averagE_MINUTES_HHMM = element.averagE_MINUTES_HHMM
      
     

      arribalAtPlantObj.image_trailer_data = this.GetResponseDetailImage(responseDetail, element, 24)
      arribalAtPlantObj.image_side_data = this.GetResponseDetailImage(responseDetail, element, 25) 
      
      var image_truck_data = this.GetResponseDetailImage(responseDetail, element, 2) 
      
      var image_truck_data_arr = [];
      
      if(image_truck_data !== undefined){
        image_truck_data_arr.push(image_truck_data)
      }

      if(arribalAtPlantObj.image_trailer_data !== null){
        image_truck_data_arr.push(arribalAtPlantObj.image_trailer_data)
      }

      if(arribalAtPlantObj.image_side_data !== null){
        image_truck_data_arr.push(arribalAtPlantObj.image_side_data)
      }

      arribalAtPlantObj.image_truck_data = image_truck_data_arr

      arribalAtPlantObj.image_license_data = this.GetResponseDetailImage(responseDetail, element, 11) 
      arribalAtPlantObj.image_truck_number_data = this.GetResponseDetailImage(responseDetail, element, 13) 
      arribalAtPlantObj.image_dot_data = this.GetResponseDetailImage(responseDetail, element, 12)
      arribalAtPlantObj.image_company_data = this.GetResponseDetailImage(responseDetail, element, 14) 

     
      arribalAtPlant.push(arribalAtPlantObj)
    })

    return arribalAtPlant
  }


  private GetResponseDetailImage(responseDetail: any, element: any, atributeType: number): any{
    var imageValues = this.GetResponseDetailImageValues(responseDetail, element, atributeType)
    
    if(imageValues[0] != null){
      return this.GetImageFromArrayBytes(imageValues[0], imageValues[1])
    }
    else{
      return null
    }
    
  }

  private GetResponseDetailImageValues(responseDetail: any, element: any, atributeType: number): [image_url: string, image_data: any] {
  
    var image_data = responseDetail.images.filter(e => e.attributeType === atributeType && element.steP_ID === e.checkpoinT_ID).map(e => [e.imagE_URL, e.image])

    if(image_data.length > 0){
      return image_data[0]
    }else{
      return [null, null]
    }
  }

  private GetImageFromArrayBytes(image_url: string, image_data: any): any {
    var re = /(?:\.([^.]+))?$/;
    var extension = re.exec(image_url)[1];
  
    let objectURL = `data:image/${extension};base64,` + image_data;

    return this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  previousSlide() {
    this.moveToPrevSlide()
  }

  moveToPrevSlide() {
    if (this.slidePosition === 0) {
      this.slidePosition = this.totalSlides - 1;
    } else {
      this.slidePosition--
    }
    this.updateSlidePosition()
  }

  nextSlide() {
    this.moveToNextSlide()
  }

  moveToNextSlide() {
    if (this.slidePosition === this.totalSlides - 1) {
      this.slidePosition = 0
    } else {
      this.slidePosition++
    }
    this.updateSlidePosition()
  }

  updateSlidePosition() {
    for (let i = 0; i < this.slides.length; i++) {
      const slide = this.slides[i];
      slide.classList.remove('carousel__item--visible')
      slide.classList.add('carousel__item--hidden')
    }
    this.slides[this.slidePosition].classList.add('carousel__item--visible')
  }

  connectionHub() {
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.notificationHub)
      .build()

    this._hubConnection.on('ReceiveNotification', () => {
      this.LoadData()
    })

    this._hubConnection.start().then(() => {
    }).catch(
      () => console.log('hub fail!!!')
    )
  }
}
